import React from "react";

const FindSuppliersIcon = ({
  color = "#5D5D5D",
  width = "16",
  height = "17",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.707031 5.21816V15.793H15.293V5.21816L8.00003 1.20703L0.707031 5.21816Z"
        stroke="#1E1E1E"
        strokeWidth="1.5"
      />
      <path
        d="M3.625 11.417V15.7928H8.0008V11.417H3.625Z"
        stroke="#1E1E1E"
        strokeWidth="1.5"
      />
      <path
        d="M8 11.417V15.7928H12.3758V11.417H8Z"
        stroke="#1E1E1E"
        strokeWidth="1.5"
      />
      <path
        d="M5.8125 7.04102V11.4168H10.1884V7.04102H5.8125Z"
        stroke="#1E1E1E"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default FindSuppliersIcon;
